// src/pages/team/TeamEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Editing a team now
// happens inline on the workspace's Settings tab (autosave property rows) —
// see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const TeamEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/teams/${id}?tab=settings` : '/teams', { replace: true });
  }, [navigate, id]);
  return null;
};

export default TeamEditPage;
